import React, { ReactElement } from 'react';
import { Box, Typography, SvgIconProps } from '@mui/material';

interface SectionHeaderProps {
  icon: React.ElementType<SvgIconProps>;
  title: string;
  subtitle?: string;
  titleVariant?: 'h3' | 'h4' | 'h5' | 'h6';
}

const SectionHeader = ({
  icon: Icon,
  title,
  subtitle,
  titleVariant = 'h5',
}: SectionHeaderProps): ReactElement => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Icon fontSize="large" color="primary" />
      <Typography variant={titleVariant} component="div">
        {title}
      </Typography>
    </Box>

    {subtitle && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeader;
